
<span [ngxTippy]="statTooltip" [tippyProps]="{ placement: 'left' }">
  {{ statText }}
</span>
